import { render, staticRenderFns } from "./ConvenioPage.vue?vue&type=template&id=2b83b1e3&scoped=true"
import script from "./ConvenioPage.js?vue&type=script&lang=js&external"
export * from "./ConvenioPage.js?vue&type=script&lang=js&external"
import style0 from "./ConvenioPage.vue?vue&type=style&index=0&id=2b83b1e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b83b1e3",
  null
  
)

export default component.exports